import runSsrSafely from '@utils/ssr/runSsrSafely';
import type {AppDispatch, RootState} from '@src/client/index';
import {fetchArchiveRequest, fetchArchiveRequestTransactions} from './archiveSlice';

interface ArchiveDetailSsrFetchStore {
    dispatch: AppDispatch;
    getState: () => RootState;
}

interface ArchiveDetailSsrFetchParams {
    archiveRequestId?: string;
}

export default function ssrFetchDetail({
    store, params, headers, timeout
}: {
    store: ArchiveDetailSsrFetchStore;
    params?: ArchiveDetailSsrFetchParams;
    headers?: Record<string, string>;
    timeout?: number;
}) {
    const archiveRequestId = params?.archiveRequestId;
    if (!archiveRequestId) {
        return Promise.resolve();
    }

    /** Settled, not all-or-nothing, same as Transaction/ssrFetch: render.tsx awaits every preload, one rejection would sink the page. */
    return runSsrSafely([
        store.dispatch(fetchArchiveRequest(archiveRequestId, {headers, timeout})),
        store.dispatch(fetchArchiveRequestTransactions(archiveRequestId, {headers, timeout}))
    ]);
}
